export default "__VITE_ASSET__CwLoxqYO__"